import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { makeStyles } from 'tss-react/mui';

const useListStyles = makeStyles()((theme) => ({
    list: Object.assign({ listStyle: 'none', overflowY: 'scroll', paddingLeft: 0, margin: 0 }, theme.styles.scrollSection),
}));

const List = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    const { classes, cx } = useListStyles();
    return (jsx("ul", Object.assign({ className: cx(classes.list, className) }, rest, { children: children })));
};

export { List };
//# sourceMappingURL=List.es.js.map
